(function(window) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.mediaType = (function() {
      return {
         WEBM: 'webm',
         MP4: 'mp4',
         OGG: 'ogg',
         YOUTUBE: 'youtube',
         JPG: 'jpg',
         PNG: 'png',
         GIF: 'gif',
         TSCPROJ: 'tscproj',
         PLAYLIST: 'playlist',
         UNKNOWN: 'unknown',
         NOT_AVAILABLE: 'not available',
         MULTIPLE_TYPES: 'multiple types'
      };
   }());
}(this));
